import {reactive} from 'vue';
import {locale} from 'devextreme/localization';
import dictDe from '@/views/develop/lang-de.json';

// Sprachwahl der Develop-Screens: pro Screen (Route-Pfad), im Browser gemerkt.
// Die Develop-Views enthalten englische Texte; tr() liefert dazu die deutsche Fassung.
const STORAGE_KEY = 'developLang';
const DEFAULT_LANG = 'en';

function load() {
    try {
        const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return stored && typeof stored === 'object' ? stored : {};
    } catch (e) {
        return {};
    }
}

const state = reactive({path: '', langs: load(), rev: 0});

export function isDevelopPath(path) {
    return typeof path === 'string' && path.startsWith('/develop/');
}

export function setPath(path) {
    state.path = path;
}

export function currentLang() {
    return state.langs[state.path] === 'de' ? 'de' : DEFAULT_LANG;
}

// remount=false: Texte wechseln über die Reaktivität, der Screen bleibt (z.B. geöffnetes Detail-Panel) bestehen
export function setLang(lang, remount = true) {
    state.langs[state.path] = lang === 'de' ? 'de' : DEFAULT_LANG;
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state.langs));
    } catch (e) {
        // Auswahl gilt dann nur bis zum Neuladen
    }
    applyLocale();
    if (remount) state.rev++;
}

/** DevExtreme-Sprache (Datum, Grid-Texte) passend zum aktuellen Screen */
export function applyLocale() {
    locale(currentLang());
}

/** Englischen Text übersetzen; ohne Eintrag bleibt der englische Text stehen */
export function tr(text) {
    if (currentLang() !== 'de' || typeof text !== 'string') return text;
    const hit = dictDe[text];
    if (hit !== undefined) return hit;
    const parts = text.match(/^(\s*)([\s\S]*?)(\s*)$/);
    const core = dictDe[parts[2]];
    return core === undefined ? text : parts[1] + core + parts[3];
}

/** Key für <router-view>: erzwingt neues Rendern des Screens beim Sprachwechsel */
export function viewKey(path) {
    return isDevelopPath(path) ? path + '|' + state.rev : undefined;
}

export default {
    install(app) {
        app.config.globalProperties.tr = tr;
        app.config.globalProperties.$devLang = currentLang;
    }
};
